<ng-template #showIcon>
  <fcom-icon *ngIf="icon; else returnBtn" [ngClass]="fullScreen ? 'ir-medium' : 'ir-small'" [name]="icon"></fcom-icon>
</ng-template>
<ng-template #returnBtn>
  <button
    [attr.aria-label]="'actions.back' | finLocalization"
    [attr.title]="'actions.back' | finLocalization"
    (click)="returnClicked.emit($event)"
  >
    <fcom-icon name="arrow-left" class="ir-xsmall"></fcom-icon>
  </button>
</ng-template>

<div class="login-dialog login-dialog-open z5" role="dialog">
  <div
    [class.grow]="fullScreen"
    [ngClass]="{ 'rounded-large shadow': !fullScreen }"
    class="content-container overflow-hidden"
  >
    <div
      class="dialog-header overflow-hidden white-bg ps-medium-x ps-medium-t ps-xsmall-b align-left"
      [ngClass]="{ 'nordic-blue-900-bg white-text': invertHeaderColors }"
    >
      <div>
        <fcom-stepper
          *ngIf="stepperSteps$ | async as steps; else showIcon"
          class="inline-block"
          [showLabels]="false"
          [steps]="steps"
          [darkMode]="true"
          [activeStep]="stepperActiveStep$ | async"
          (clicked)="stepperClicked.emit($event)"
        ></fcom-stepper>
        <button
          class="float-right"
          [class.nordic-blue-900-text]="!invertHeaderColors"
          [attr.aria-label]="'actions.close' | finLocalization"
          [attr.title]="'actions.close' | finLocalization"
          (click)="closeClicked.emit($event)"
        >
          <fcom-icon name="close-delete" class="ir-xsmall"></fcom-icon>
        </button>
      </div>

      <h1 [ngClass]="fullScreen ? 'font-heading-2' : 'font-heading-4'" class="ps-medium-t" #dialogTitle tabindex="-1">
        {{ title | finLocalization }}
      </h1>

      <fcom-notification *ngIf="error" class="mr-small-t" [theme]="NotificationTheme.ALERT">
        <span class="font-body-1">{{ error | finLocalization }}</span>
      </fcom-notification>

      <p class="font-body-1 ms-medium-b ms-large-t">
        {{ description | finLocalization }}
      </p>

      <ng-content select=".header-content"></ng-content>
    </div>
    <div class="dialog-content overflow-hidden white-bg ps-medium-x ps-medium-b ps-xsmall-t align-left">
      <ng-content></ng-content>
    </div>
  </div>
</div>
